module.exports = __webpack_public_path__ + "static/media/tree_15.6ee7a6c9.jpg";